import React, { useState, useEffect } from "react";
import {
    Breadcrumb, Layout
} from "antd";
import Nav from "../components/Nav";
import HeaderJs from "../components/HeaderJs";
import FooterJs from "../components/FooterJs";
import PowerBI from "../components/PowerBI";
import BackendService from "../components/BackendService";


const { Header, Content } = Layout;

// Reports component that displays Power BI reports
// It fetches the report token from the backend and renders the Power BI component
const Reports = () => {

    // const [token, SetToken] = useState('');
    const powerBIAppUrl = "https://app.powerbi.com/groups/b92ead50-fa12-41d2-b5a7-f3d639acdde0/reports/89f86def-062b-497b-a98f-4d5969c91481/f550446bb0b54e599c16?language=en-US&experience=power-bi";

    // useEffect(() => {
    //     BackendService.FetchReportToken()
    //         .then((response) => {
    //             SetToken(response.data);
    //         })
    //         .catch((error) => {
    //             console.error("Error:", error);
    //             SetToken([]);
    //         });
    // }, []);


    return (
        <div className="SCAUX">
            <Layout>
                <Header className="header" >
                    <HeaderJs />
                </Header>
                <Layout>
                    <Nav />
                    <Content >
                        <div className="content">
                            <div id="scrollableDiv" className="scrollable-content">
                                <div className="searchfilter">
                                    <Breadcrumb
                                        className="page-title"
                                    >
                                        <Breadcrumb.Item>
                                            <span className="page-title-label">Reports</span>
                                        </Breadcrumb.Item>
                                    </Breadcrumb>
                                </div>
                                <PowerBI
                                    appUrl={powerBIAppUrl}
                                    appName="SCIA Reporting"
                                />
                            </div>
                        </div>
                    </Content>
                </Layout>
                <FooterJs />
            </Layout>
        </div>
    );
}

export default Reports;